<script setup lang="ts">
    import { ref, computed, watch, onMounted, toRef } from 'vue'
    import { formatStringForDateInput } from "@common/Common"

    import type { AlternativeEditorAttributeFieldReadModel } from "@Alternatives/Alternatives/Domain/readmodels"
    import type { ValidationError } from "@common/types"

    /* props */

    const props = defineProps<{
        propF: AlternativeEditorAttributeFieldReadModel
        propErrors: ValidationError[]
    }>()

    /* shortcuts */

    const f = toRef(props, 'propF')
    const errors = toRef(props, 'propErrors')

    /* derived */

    const error = computed(() =>
        errors.value?.find(e =>
            e.Context.startsWith(`AlternativeAttribute:${f.value.Id}`)
        )?.Error
    )

    /* local state */

    const values = ref<string[]>([])

    /* defined values (derived, not state) */

    const definedValues = computed(() =>
        f.value.DefinedValues.map(dv => ({
            value: formatStringForDateInput(dv.Value),
            label: dv.Label
        }))
    )

    /* sync back to domain */

    watch(values, (vals) =>
    {
        f.value.Values = vals
    })

    /* init */

    onMounted(() =>
    {
        values.value = f.value.Values.map(v => formatStringForDateInput(v))
    })
</script>


<template>
    <div class="form-group">
        <label>
            <span v-if="f.IsRequired" style="color: red;">*</span> {{ f.Name }}
        </label>

        <select v-model="values"
                class="form-control"
                multiple
                :required="f.IsRequired"
                :disabled="f.IsReadonly">
            <option v-for="dv in definedValues"
                    :key="dv.value"
                    :value="dv.value">
                {{ dv.label }}
            </option>
        </select>

        <div class="error">{{ error }}</div>

        <small v-if="f.Description" class="form-text text-muted">
            {{ f.Description }}
        </small>
    </div>
</template>

